<template>
<button :class="classStyle" :title="title" @click="onClick">
  <i :class="iconClass"></i>
  {{title}}
</button>
</template>

<script>
export default {
  name: 'ActionButtonClick',
  props: {
    classStyle: {},
    title: {},
    iconClass: {},
    handleEvent: {},
    params: {}
  },

  methods: {
    onClick () {
      this.handleEvent.click(this.params)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/ActionButtonClick.vue